import PropTypes from 'prop-types';
import React from 'react';
import Text from '../Text/index.js';

/**
 *  Describe the component
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function OverlineText(_ref) {
  let {
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(Text, {
    size: 200,
    color: "subdued-lighter",
    transformCase: "uppercase",
    ...rest
  });
}
export default OverlineText;